<div class="container mx-auto py-10" (click)="closeAllPopovers()">
  <!-- Header -->
  <div class="flex items-center justify-between space-y-2 mb-8">
    <div>
      <h2 class="text-3xl font-bold tracking-tight">Usuarios y Seguridad Avanzada</h2>
      <p class="text-muted-foreground">Gestión completa de usuarios, 2FA, bloqueos y configuraciones de seguridad</p>
    </div>
  </div>

  <!-- Stats Cards -->
  <div *ngIf="!loading" class="grid gap-4 md:grid-cols-2 lg:grid-cols-5 mb-8">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Total Usuarios</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold">{{ stats.total }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">2FA Authenticator</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold text-green-600">{{ stats.with2FAAuthenticator }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">2FA SMS</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold text-blue-600">{{ stats.with2FASMS }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Bloqueados</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold text-red-600">{{ stats.locked }}</div>
      </div>
    </div>
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 class="tracking-tight text-sm font-medium">Sesiones Activas</h3>
      </div>
      <div class="p-6 pt-0">
        <div class="text-2xl font-bold">{{ stats.activeSessions }}</div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div *ngIf="!loading" class="rounded-lg border bg-card text-card-foreground shadow-sm mb-8">
    <div class="flex items-center justify-between p-6">
      <h3 class="text-2xl font-semibold leading-none tracking-tight">Filtros</h3>
      <button data-rbac-permiso="config.seguridad.config" *ngIf="_auth.hasPermission('config.seguridad.config')" (click)="openGlobalModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
          <path
            d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        Gestión Global 2FA
      </button>
    </div>
    <div class="p-6 pt-0">
      <div class="grid gap-4 md:grid-cols-3">
        <div class="grid w-full items-center gap-1.5">
          <label class="text-sm font-medium leading-none">Buscar</label>
          <input type="text" [(ngModel)]="filters.searchTerm" (input)="onFilterChange()"
            placeholder="Usuario, email, nombre..."
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
        </div>
        <div class="grid w-full items-center gap-1.5">
          <label class="text-sm font-medium leading-none">Estado 2FA</label>
          <select [(ngModel)]="filters.status2FA" (change)="onFilterChange()"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="all">Todos</option>
            <option value="enabled">Con 2FA</option>
            <option value="disabled">Sin 2FA</option>
          </select>
        </div>
        <div class="grid w-full items-center gap-1.5">
          <label class="text-sm font-medium leading-none">Estado Cuenta</label>
          <select [(ngModel)]="filters.accountStatus" (change)="onFilterChange()"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="all">Todas</option>
            <option value="locked">Bloqueadas</option>
            <option value="active">Activas</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex items-center justify-center py-20">
    <div class="text-center">
      <div
        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent">
      </div>
      <p class="mt-4 text-sm text-muted-foreground">Cargando usuarios...</p>
    </div>
  </div>

  <!-- Refresh Button -->
  <div *ngIf="!loading" class="flex justify-end mb-4">
    <button (click)="refreshUsers()" [disabled]="loading"
      class="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2">
        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
      </svg>
      Actualizar
    </button>
  </div>

  <!-- Table -->
  <div *ngIf="!loading && usersFiltered.length > 0" class="rounded-md border">
    <table class="w-full caption-bottom text-sm">
      <thead class="[&_tr]:border-b">
        <tr class="border-b transition-colors hover:bg-muted/50">
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Usuario</th>
          <th class="h-12 px-4 text-left align-middle font-medium text-muted-foreground">Email</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">2FA Authenticator</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">2FA SMS</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Estado Conexión</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Última Conexión</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Dispositivos</th>
          <th class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Estado Cuenta</th>
          <th data-rbac-permiso="config.seguridad.update" *ngIf="_auth.hasPermission('config.seguridad.update')" class="h-12 px-4 text-center align-middle font-medium text-muted-foreground">Acciones</th>
        </tr>
      </thead>
      <tbody class="[&_tr:last-child]:border-0">
        <tr *ngFor="let user of usersPaginated" class="border-b transition-colors hover:bg-muted/50">
          <td class="p-4 align-middle font-medium">
            <div>
              <div class="font-semibold">{{ user.username }}</div>
              <div class="text-xs text-muted-foreground">{{ getFullName(user) }}</div>
            </div>
          </td>
          <td class="p-4 align-middle text-sm">{{ user.email }}</td>
          <td class="p-4 align-middle text-center">
            <div class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="user.twoFactorAuthenticator.enabled ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'">
              {{ user.twoFactorAuthenticator.enabled ? 'Activo' : 'Inactivo' }}
            </div>
          </td>
          <td class="p-4 align-middle text-center">
            <div class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="user.twoFactorSMS.enabled ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'">
              {{ user.twoFactorSMS.enabled ? 'Activo' : 'Inactivo' }}
            </div>
          </td>
          <td class="p-4 align-middle text-center">
            <div class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="user.isOnline ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'">
              <span class="inline-block w-2 h-2 rounded-full mr-1.5"
                [ngClass]="user.isOnline ? 'bg-green-600' : 'bg-gray-600'"></span>
              {{ user.isOnline ? 'Online' : 'Offline' }}
            </div>
          </td>
          <td class="p-4 align-middle text-center text-sm">
            <span *ngIf="user.lastConnection" class="text-muted-foreground">
              {{ formatDate(user.lastConnection) }}
            </span>
            <span *ngIf="!user.lastConnection" class="text-muted-foreground italic">
              Nunca
            </span>
          </td>
          <td class="p-4 align-middle text-center">
            <button *ngIf="(user.trustedDevices?.count || 0) > 0"
              (click)="openTrustedDevicesModal(user); $event.stopPropagation()"
              class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold bg-purple-100 text-purple-800 hover:bg-purple-200 cursor-pointer transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1">
                <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                <path d="M12 18h.01" />
              </svg>
              {{ user.trustedDevices?.count || 0 }}
            </button>
            <span *ngIf="!(user.trustedDevices?.count)" class="text-xs text-muted-foreground">0</span>
          </td>
          <td class="p-4 align-middle text-center">
            <div class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="(user.accountLock.isLocked || user.accountLock.permanentlyLocked) ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'">
              {{ (user.accountLock.isLocked || user.accountLock.permanentlyLocked) ? 'Bloqueada' : 'Activa' }}
            </div>
          </td>
          <td data-rbac-permiso="config.seguridad.update" *ngIf="_auth.hasPermission('config.seguridad.update')" class="p-4 align-middle">
            <div class="flex justify-center relative">
              <!-- Trigger Button -->
              <button (click)="togglePopover(user.id); $event.stopPropagation()"
                class="popover-trigger inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 w-9">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
                  <circle cx="12" cy="12" r="1" />
                  <circle cx="12" cy="5" r="1" />
                  <circle cx="12" cy="19" r="1" />
                </svg>
              </button>

              <!-- Popover Content -->
              <div *ngIf="isPopoverOpen(user.id)"
                class="popover-content absolute right-0 top-10 z-50 w-56 rounded-md border bg-popover p-1 text-popover-foreground shadow-md outline-none animate-in fade-in-0 zoom-in-95">
                <div class="flex flex-col gap-1">
                  <button data-rbac-permiso="config.seguridad.update" *ngIf="_auth.hasPermission('config.seguridad.update')" (click)="openManageModal(user); $event.stopPropagation()"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="mr-2 h-4 w-4">
                      <path
                        d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                    Gestionar 2FA
                  </button>
                  <button (click)="viewLoginHistory(user); $event.stopPropagation()"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="mr-2 h-4 w-4">
                      <path d="M3 3v18h18" />
                      <path d="m19 9-5 5-4-4-3 3" />
                    </svg>
                    Ver Historial de Logins
                  </button>
                  <button (click)="openTrustedDevicesModal(user); $event.stopPropagation()"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="mr-2 h-4 w-4">
                      <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                      <path d="M12 18h.01" />
                    </svg>
                    Ver Dispositivos de Confianza
                  </button>
                  <div class="h-px bg-border my-1"
                    *ngIf="user.accountLock.isLocked || user.accountLock.permanentlyLocked"></div>
                  <button data-rbac-permiso="config.seguridad.update" *ngIf="(user.accountLock.isLocked || user.accountLock.permanentlyLocked) && _auth.hasPermission('config.seguridad.update')"
                    (click)="unlockAccount(user)"
                    class="relative flex cursor-pointer select-none items-center rounded-sm px-2 py-2 text-sm outline-none transition-colors text-green-600 hover:bg-green-50 focus:bg-accent focus:text-accent-foreground w-full text-left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="mr-2 h-4 w-4">
                      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 9.9-1" />
                    </svg>
                    Desbloquear Cuenta
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div *ngIf="!loading && usersFiltered.length > 0" class="flex items-center justify-between px-2 py-4">
    <div class="text-sm text-muted-foreground">
      Mostrando {{ (currentPage - 1) * pageSize + 1 }} a {{ Math.min(currentPage * pageSize, usersFiltered.length) }} de
      {{ usersFiltered.length }} usuarios
    </div>
    <div class="flex items-center space-x-2">
      <button (click)="previousPage()" [disabled]="currentPage === 1"
        class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
          <path d="m15 18-6-6 6-6" />
        </svg>
        Anterior
      </button>
      <div class="flex items-center gap-1">
        <span class="text-sm font-medium">Página {{ currentPage }} de {{ totalPages }}</span>
      </div>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages"
        class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
        Siguiente
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4">
          <path d="m9 18 6-6-6-6" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && usersFiltered.length === 0" class="text-center py-20">
    <h3 class="text-xl font-semibold">{{ hasActiveFilters() ? 'No se encontraron usuarios' : 'No hay usuarios
      registrados' }}</h3>
    <p class="text-sm text-muted-foreground mt-2">
      {{ hasActiveFilters() ? 'No hay usuarios que coincidan con los filtros.' : 'No hay usuarios en el sistema.' }}
    </p>
  </div>
</div>

<!-- Modal de Gestión de 2FA -->
<div *ngIf="showManageModal" class="fixed inset-0 z-50 bg-black/80" (click)="closeManageModal()">
  <div
    class="fixed left-[50%] top-[50%] z-50 w-full max-w-xl translate-x-[-50%] translate-y-[-50%] border bg-background shadow-lg sm:rounded-lg">
    <div class="max-h-[80vh] overflow-y-auto p-5 sm:p-6 space-y-4" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex flex-col space-y-1.5 border-b pb-4">
        <h2 class="text-xl font-semibold">Gestionar 2FA - {{ selectedUser?.username }}</h2>
        <p class="text-sm text-muted-foreground">Administra las configuraciones de autenticación de dos factores</p>
      </div>

      <div *ngIf="selectedUser" class="space-y-6">
        <!-- 2FA Authenticator -->
        <div class="space-y-3">
          <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="9" x="3" y="3" rx="1" />
              <rect width="7" height="5" x="14" y="3" rx="1" />
              <rect width="7" height="9" x="14" y="12" rx="1" />
              <rect width="7" height="5" x="3" y="16" rx="1" />
            </svg>
            Google Authenticator
          </h3>
          <div class="rounded-md border p-4 space-y-3">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium">Estado:
                  <span [ngClass]="selectedUser.twoFactorAuthenticator.enabled ? 'text-green-600' : 'text-gray-600'">
                    {{ selectedUser.twoFactorAuthenticator.enabled ? 'Configurado' : 'No Configurado' }}
                  </span>
                </p>
                <p class="text-xs text-muted-foreground mt-1" *ngIf="selectedUser.twoFactorAuthenticator.enabled">
                  Códigos de respaldo: {{ selectedUser.twoFactorAuthenticator.backupCodesRemaining }}
                </p>
              </div>
              <button *ngIf="selectedUser.twoFactorAuthenticator.enabled" (click)="reset2FAAuthenticator()"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
                Resetear Authenticator
              </button>
            </div>

            <!-- Toggle Activar/Desactivar - SIEMPRE VISIBLE -->
            <div class="border-t pt-3">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <p class="text-sm font-medium">Activar/Desactivar para Login</p>
                  <p class="text-xs text-muted-foreground mt-1">
                    {{ selectedUser.twoFactorAuthenticator.active ? 'Aparecerá como opción al iniciar sesión' : 'NO
                    aparecerá como opción al iniciar sesión' }}
                  </p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer ml-4">
                  <input type="checkbox" [checked]="selectedUser.twoFactorAuthenticator.active"
                    (change)="toggle2FAAuthenticator(!selectedUser.twoFactorAuthenticator.active)" class="sr-only peer">
                  <div
                    class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                  </div>
                </label>
              </div>
            </div>

            <!-- Agregar/Editar Correo -->
            <div class="border-t pt-3 mt-3">
              <label class="text-sm font-medium leading-none">Correo Electrónico</label>
              <div class="flex gap-2 mt-2">
                <input type="email" [(ngModel)]="emailForm.email" placeholder="usuario@dominio.com"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                <button (click)="setUserEmail()"
                  class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
                  Guardar
                </button>
                <button (click)="deleteUserEmail()" [disabled]="!selectedUser?.email"
                  class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-destructive bg-background text-destructive hover:bg-destructive hover:text-destructive-foreground h-10 px-4 py-2 disabled:opacity-50 disabled:pointer-events-none">
                  Eliminar
                </button>
              </div>
              <p class="text-xs text-muted-foreground mt-1">Requerido para activar Authenticator</p>
            </div>
          </div>
        </div>

        <!-- 2FA SMS -->
        <div class="space-y-3">
          <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
              <path d="M12 18h.01" />
            </svg>
            SMS 2FA
          </h3>
          <div class="rounded-md border p-4 space-y-3">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium">Estado:
                  <span [ngClass]="selectedUser.twoFactorSMS.enabled ? 'text-blue-600' : 'text-gray-600'">
                    {{ selectedUser.twoFactorSMS.enabled ? 'Configurado' : 'No Configurado' }}
                  </span>
                </p>
                <p class="text-xs text-muted-foreground mt-1" *ngIf="selectedUser.twoFactorSMS.phone">
                  Teléfono: +58 {{ selectedUser.twoFactorSMS.phone }}
                </p>
              </div>
              <button *ngIf="selectedUser.twoFactorSMS.enabled" (click)="reset2FASMS()"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
                Resetear SMS 2FA
              </button>
            </div>

            <!-- Toggle Activar/Desactivar - SIEMPRE VISIBLE -->
            <div class="border-t pt-3">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <p class="text-sm font-medium">Activar/Desactivar para Login</p>
                  <p class="text-xs text-muted-foreground mt-1">
                    {{ selectedUser.twoFactorSMS.active ? 'Aparecerá como opción al iniciar sesión' : 'NO aparecerá como
                    opción al iniciar sesión' }}
                  </p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer ml-4">
                  <input type="checkbox" [checked]="selectedUser.twoFactorSMS.active"
                    (change)="toggle2FASMS(!selectedUser.twoFactorSMS.active)" class="sr-only peer">
                  <div
                    class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                  </div>
                </label>
              </div>
            </div>

            <!-- Agregar/Editar Teléfono -->
            <div class="border-t pt-3">
              <label class="text-sm font-medium leading-none">Número de Teléfono</label>
              <div class="flex gap-2 mt-2">
                <input type="text" [(ngModel)]="phoneForm.phone" placeholder="4241234567" maxlength="10"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                <button (click)="setUserPhone()"
                  class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
                  Guardar
                </button>
              </div>
              <p class="text-xs text-muted-foreground mt-1">Formato: 10 dígitos sin código de país</p>
            </div>
          </div>
        </div>

        <!-- Bloqueo de Cuenta -->
        <div class="space-y-3" *ngIf="selectedUser.accountLock.lockIncidents > 0">
          <h3 class="text-sm font-semibold text-foreground flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Información de Bloqueo
          </h3>
          <div class="rounded-md border p-4">
            <p class="text-sm">Incidencias de bloqueo: <span class="font-semibold">{{
                selectedUser.accountLock.lockIncidents }}</span></p>
            <p class="text-sm mt-1">Intentos fallidos: <span class="font-semibold">{{
                selectedUser.accountLock.loginAttempts }}</span></p>
            <button (click)="resetIncidents(selectedUser)"
              class="mt-3 inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-4 py-2">
              Resetear Incidencias
            </button>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="flex justify-end">
        <button (click)="closeManageModal()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Historial de Logins -->
<div *ngIf="showLoginHistoryModal" class="fixed inset-0 z-[60] bg-black/80" (click)="closeLoginHistoryModal()">
  <div
    class="fixed left-[50%] top-[50%] z-[60] grid w-full max-w-4xl translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex flex-col space-y-1.5 border-b pb-4">
      <h2 class="text-xl font-semibold">Historial de Logins - {{ selectedUser?.username }}</h2>
      <p class="text-sm text-muted-foreground">Registro completo de inicios de sesión</p>
    </div>

    <!-- Loading -->
    <div *ngIf="loadingHistory" class="flex items-center justify-center py-10">
      <div
        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent">
      </div>
    </div>

    <!-- Login History Table -->
    <div *ngIf="!loadingHistory && loginHistory.length > 0" class="rounded-md border">
      <table class="w-full caption-bottom text-sm">
        <thead class="border-b bg-muted/50">
          <tr class="border-b transition-colors">
            <th
              class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">
              Fecha/Hora</th>
            <th
              class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">
              IP</th>
            <th
              class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">
              Ubicación</th>
            <th
              class="h-10 px-4 text-left align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">
              Dispositivo</th>
            <th
              class="h-10 px-4 text-center align-middle font-medium text-muted-foreground text-xs uppercase tracking-wide">
              Estado</th>
          </tr>
        </thead>
        <tbody class="[&_tr:last-child]:border-0">
          <tr *ngFor="let login of loginHistory" class="border-b transition-colors hover:bg-muted/50">
            <td class="p-3 align-middle text-xs">{{ formatDate(login.timestamp) }}</td>
            <td class="p-3 align-middle text-xs font-mono">{{ login.ip }}</td>
            <td class="p-3 align-middle text-xs">{{ getLocationString(login.location) }}</td>
            <td class="p-3 align-middle text-xs">{{ getDeviceString(login.device) }}</td>
            <td class="p-3 align-middle text-center">
              <div class="inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold"
                [ngClass]="login.suspicious ? 'bg-red-100 text-red-800 border-red-200' : (login.loginSuccess ? 'bg-green-100 text-green-800 border-green-200' : 'bg-gray-100 text-gray-800 border-gray-200')">
                {{ login.suspicious ? 'Sospechoso' : (login.loginSuccess ? 'Exitoso' : 'Fallido') }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingHistory && loginHistory.length === 0" class="text-center py-10">
      <p class="text-sm text-muted-foreground">No hay historial de logins disponible</p>
    </div>

    <!-- Footer -->
    <div class="flex justify-end">
      <button (click)="closeLoginHistoryModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Modal de Gestión Global 2FA -->
<div *ngIf="showGlobalModal" class="fixed inset-0 z-[60] bg-black/80" (click)="closeGlobalModal()">
  <div
    class="fixed left-[50%] top-[50%] z-[60] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex flex-col space-y-1.5 border-b pb-4">
      <h2 class="text-xl font-semibold">Gestión Global de 2FA</h2>
      <p class="text-sm text-muted-foreground">Controla si el sistema requiere 2FA globalmente</p>
    </div>

    <!-- Content -->
    <div class="space-y-4">
      <div class="rounded-md border p-4">
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <p class="text-sm font-medium">Estado Global de 2FA</p>
            <p class="text-xs text-muted-foreground mt-1">
              {{ global2FAEnabled ? 'Los usuarios con 2FA configurado DEBEN usarlo al iniciar sesión' : 'Los usuarios
              NO necesitan 2FA al iniciar sesión aunque lo tengan configurado' }}
            </p>
          </div>
          <div class="ml-4">
            <span class="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="global2FAEnabled ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
              {{ global2FAEnabled ? 'Activado' : 'Desactivado' }}
            </span>
          </div>
        </div>
      </div>

      <div class="rounded-md bg-blue-50 border border-blue-200 p-4">
        <div class="flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="text-blue-600 mr-3 flex-shrink-0">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <div class="text-sm text-blue-800">
            <p class="font-semibold mb-1">Importante:</p>
            <ul class="list-disc list-inside space-y-1 text-xs">
              <li>Si está <strong>activado</strong>: Los usuarios con 2FA configurado y activo deberán usarlo al
                iniciar sesión</li>
              <li>Si está <strong>desactivado</strong>: Ningún usuario necesitará 2FA al iniciar sesión,
                independientemente de su configuración individual</li>
              <li>Los toggles individuales por usuario seguirán funcionando cuando el 2FA global esté activado</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-between gap-3">
      <button (click)="closeGlobalModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
        Cancelar
      </button>
      <button (click)="toggleGlobal2FA()" [disabled]="loadingGlobal2FA"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2"
        [ngClass]="global2FAEnabled ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-green-600 text-white hover:bg-green-700'">
        <span *ngIf="!loadingGlobal2FA">{{ global2FAEnabled ? 'Desactivar Globalmente' : 'Activar Globalmente'
          }}</span>
        <span *ngIf="loadingGlobal2FA" class="flex items-center">
          <div
            class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent mr-2">
          </div>
          Procesando...
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Modal de Dispositivos de Confianza -->
<div *ngIf="showTrustedDevicesModal" class="fixed inset-0 z-[60] bg-black/80" (click)="closeTrustedDevicesModal()">
  <div
    class="fixed left-[50%] top-[50%] z-[60] grid w-full max-w-3xl translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg sm:rounded-lg max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex flex-col space-y-1.5 border-b pb-4">
      <div class="flex items-center justify-between">
        <div>
          <h2 class="text-xl font-semibold">Dispositivos de Confianza - {{ trustedDevicesUser?.username }}</h2>
          <p class="text-sm text-muted-foreground">Dispositivos que pueden saltar la verificación 2FA</p>
        </div>
        <button *ngIf="trustedDevicesList.length > 0" (click)="revokeAllTrustedDevices()" [disabled]="revokingAll"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-red-600 text-white hover:bg-red-700 h-9 px-4 py-2 disabled:opacity-50">
          <span *ngIf="!revokingAll">Revocar Todos</span>
          <span *ngIf="revokingAll" class="flex items-center">
            <div
              class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent mr-2">
            </div>
            Revocando...
          </span>
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loadingTrustedDevices" class="flex items-center justify-center py-10">
      <div
        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent">
      </div>
    </div>

    <!-- Devices List -->
    <div *ngIf="!loadingTrustedDevices && trustedDevicesList.length > 0" class="space-y-3">
      <div *ngFor="let device of trustedDevicesList" class="rounded-md border p-4"
        [ngClass]="device.isExpired ? 'opacity-60 bg-gray-50' : ''">
        <div class="flex items-start justify-between">
          <div class="flex items-start gap-3">
            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-purple-600">
                <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                <path d="M12 18h.01" />
              </svg>
            </div>
            <div>
              <p class="text-sm font-semibold">{{ device.deviceName }}</p>
              <div class="mt-1 space-y-0.5">
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">Navegador:</span> {{ device.browser }}
                </p>
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">SO:</span> {{ device.os }}
                </p>
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">IP:</span> {{ device.ip }}
                </p>
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">Confiado desde:</span> {{ formatDate(device.createdAt) }}
                </p>
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">Último uso:</span> {{ formatDate(device.lastUsedAt) }}
                </p>
                <p class="text-xs text-muted-foreground">
                  <span class="font-medium">Expira:</span> {{ formatDate(device.expiresAt) }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <span *ngIf="device.isExpired"
              class="inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold bg-red-100 text-red-800">
              Expirado
            </span>
            <span *ngIf="!device.isExpired"
              class="inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold bg-green-100 text-green-800">
              Activo
            </span>
            <button (click)="revokeTrustedDevice(device.deviceId)" [disabled]="revokingDeviceId === device.deviceId"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-red-200 text-red-600 hover:bg-red-50 h-8 px-3 py-1 disabled:opacity-50">
              <span *ngIf="revokingDeviceId !== device.deviceId">Revocar</span>
              <span *ngIf="revokingDeviceId === device.deviceId">
                <div
                  class="inline-block h-3 w-3 animate-spin rounded-full border-2 border-solid border-current border-r-transparent">
                </div>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loadingTrustedDevices && trustedDevicesList.length === 0" class="text-center py-10">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
        class="mx-auto text-muted-foreground mb-4">
        <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
        <path d="M12 18h.01" />
      </svg>
      <p class="text-sm text-muted-foreground">Este usuario no tiene dispositivos de confianza</p>
    </div>

    <!-- Footer -->
    <div class="flex justify-end border-t pt-4">
      <button (click)="closeTrustedDevicesModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2">
        Cerrar
      </button>
    </div>
  </div>
</div>